export const infoBoxContentStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  justifyContent: 'space-between',
  alignItems: 'center',
  bgcolor: 'background.paper',
  gap: 2,
  py: 2,
  px: 4,
}
